import {
  GlobalThemeConfiguration,
  TabsOrientationStyleConfigurations,
  TabsStyleConfigurations,
} from '../config.type';
import { TabsOrientationType } from '../default-constants/layout-widgets.type';
import { MappedStyles } from './global-themeing.utils';

export const GLOBAL_TAB_STYLING_CLASS = 'global-tab-styling';

const GLOBAL_STYLING_ROOT_SELECTOR = '#web-app';

export const DEFAULT_TAB_CSS_SCAFFOLD = `hlm-tabs-list {
}
hlm-tabs-list button {
}
hlm-tabs-list button:hover {
}
hlm-tabs-list button[data-state=active] {
}`;

function tabsGlobalScopeSelector(orientation: TabsOrientationType): string {
  return `.${GLOBAL_TAB_STYLING_CLASS}[data-orientation='${orientation}']`;
}

export function mapTabsStylesToCssString(theme: GlobalThemeConfiguration): MappedStyles {
  const result: MappedStyles = {};
  Object.values(TabsOrientationType).forEach((orientation) => {
    const outerCss = theme?.tabsConfigurations?.[orientation]?.outerCss?.trim();
    if (outerCss) {
      result[
        `${GLOBAL_STYLING_ROOT_SELECTOR} section:has(> hlm-tabs${tabsGlobalScopeSelector(orientation)})`
      ] = outerCss;
    }
  });
  return result;
}

export function transformCSSWithDynamicSelector(css: string, id: string): string {
  return css.replace(/(^|\})\s*([^{]+)/g, (_, closeBrace, selector) => {
    const scopedSelector = selector
      .split(',')
      .map((s: string) => `${id} ${s.trim()}`)
      .join(', ');
    return `${closeBrace} ${scopedSelector}`;
  });
}

export function getTabsRawCssString(theme: GlobalThemeConfiguration): string {
  return Object.values(TabsOrientationType)
    .map((orientation) => {
      const tabCss = theme?.tabsConfigurations?.[orientation]?.tabCss?.trim();
      return tabCss
        ? `\n${transformCSSWithDynamicSelector(
            tabCss,
            `${GLOBAL_STYLING_ROOT_SELECTOR} ${tabsGlobalScopeSelector(orientation)}`,
          )}\n`
        : '';
    })
    .join('');
}

export function tabsOrientationStyleDefaults(): TabsOrientationStyleConfigurations {
  return {
    outerCss: '',
    tabCss: DEFAULT_TAB_CSS_SCAFFOLD,
  };
}

export function tabsStyleDefaults(): TabsStyleConfigurations {
  return {
    [TabsOrientationType.HORIZONTAL]: tabsOrientationStyleDefaults(),
    [TabsOrientationType.VERTICAL]: tabsOrientationStyleDefaults(),
  };
}
